// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const indeedee_male: PokeData = {
  "id": 876,
  "name": "indeedee-male",
  "height": 9,
  "weight": 280,
  "base_experience": 166,
  "types": [
    PokeType.PSYCHIC,
    PokeType.NORMAL
  ],
  "api_moves": [
    "psybeam",
    "psychic",
    "encore",
    "helping-hand",
    "aromatherapy",
    "calm-mind",
    "healing-wish",
    "last-resort",
    "power-split",
    "after-you",
    "stored-power",
    "disarming-voice",
    "play-nice",
    "psychic-terrain"
  ],
  "moves": [
    "psychic",
    "aromatherapy",
    "calm-mind",
    "healing-wish",
    "psychic-terrain",
    "scratch",
    "reflect",
    "zen-headbutt",
    "scary-face",
    "psychic-fangs",
    "kinesis",
    "psy-ball",
    "synchronize"
  ],
  "evolution_chain": {
    "id": 458,
    "item": null,
    "species": [
      {
        "name": "indeedee",
        "order": 876,
        "types": [
          PokeType.PSYCHIC,
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 101,
    "speed": 142,
    "ability_power": 157
  },
  "stat_changes": [],
  "catch_rate": 30,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
